module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_5012.9018f150.png";